import _ from "lodash";
import actionTypes from "actionTypes/coeus";

export default function profileReducer(
	state = {
		section: {
			title: "",
			description: ""
		},
		sectionPayload: {},
		currentSectionIndex: 0,
		fetchingSection: false
	},
	action
) {
	let newState = null;
	switch (action.type) {
		case actionTypes.FETCH_SECTION_REQUEST:
			newState = _.cloneDeep(state);
			newState.fetchingSection = true;
			return newState;
		case actionTypes.FETCH_SECTION_FINISHED:
			newState = _.cloneDeep(state);
			newState.fetchingSection = false;
			return newState;
		case actionTypes.SAVE_FIELD_LOCALLY:
			newState = _.cloneDeep(state);
			newState.sectionPayload[action.payload.questionId] = action.payload;
			return newState;
		case actionTypes.EMPTY_SAVED_LOCAL_DATA:
			newState = _.cloneDeep(state);
			newState.sectionPayload = {};
			return newState;
		case actionTypes.SET_SECTION:
			newState = _.cloneDeep(state);
			newState.section = action.payload;
			newState.fetchingSection = false;
			return newState;
		case actionTypes.SET_CURRENT_SECTION_INDEX:
			newState = _.cloneDeep(state);
			newState.currentSectionIndex = action.payload;
			return newState;
	}
	return state;
}
